import { useState } from "react";

function ImageUpload({ onChange, multiple = false, label = "Upload Images" }) {
    const [isDragging, setIsDragging] = useState(false);

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setIsDragging(true);
        } else if (e.type === "dragleave") {
            setIsDragging(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            onChange(e.dataTransfer.files);
        }
    };

    return (
        <div
            className={`image-upload-dropzone ${isDragging ? "dragging" : ""} animate-fade-in`}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
            style={{
                border: "2px dashed var(--border)",
                borderRadius: "20px",
                padding: "40px 20px",
                textAlign: "center",
                transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
                background: isDragging ? "rgba(99, 102, 241, 0.05)" : "#f8fafc",
                borderColor: isDragging ? "var(--primary)" : "var(--border)",
                cursor: "pointer",
                position: "relative"
            }}
        >
            <input
                type="file"
                multiple={multiple}
                onChange={(e) => onChange(e.target.files)}
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    cursor: "pointer"
                }}
            />

            <div style={{ color: "var(--primary)", marginBottom: "12px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
            </div>

            <h4 style={{ margin: "0 0 4px 0", color: "var(--text-dark)", fontWeight: "700" }}>{label}</h4>
            <p style={{ margin: 0, color: "var(--text-muted)", fontSize: "0.85rem" }}>
                Drag and drop files here, or click to browse
            </p>
        </div>
    );
}

export default ImageUpload;